import styled from 'styled-components';
import { grid } from '@finect/tabular-utils/grid';

export const CTA = styled.div`
  max-width: ${grid(3)}px;
  margin: 54px auto 0;
`;
